export enum EColumnTypeEnum {
  VALUE = 'value',
  ACTION = 'action',
  IMAGE = 'image',
  DATE = 'date',
  BOOLEAN_BADGE = 'boolean_badge'
}
